import { render } from "./PaperSideNav.vue?vue&type=template&id=2d0faeb2&scoped=true"
import script from "./PaperSideNav.vue?vue&type=script&lang=js"
export * from "./PaperSideNav.vue?vue&type=script&lang=js"

import "./PaperSideNav.vue?vue&type=style&index=0&id=2d0faeb2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2d0faeb2"

export default script